import { render, staticRenderFns } from "./match-listing.vue?vue&type=template&id=156315e1&"
import script from "./match-listing.vue?vue&type=script&lang=js&"
export * from "./match-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports